import { render, staticRenderFns } from "./FormCreateView.vue?vue&type=template&id=409a51c8&"
import script from "./FormCreateView.vue?vue&type=script&lang=js&"
export * from "./FormCreateView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports